import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { CategoriesProvider } from "./contexts/CategoriesContext";
import { CookieConsentProvider } from "./contexts/CookieConsentContext";
import { AuthProvider } from "./contexts/AuthContext";
import { Suspense, useEffect } from "react";
import FullPageLoader from "./components/FullPageLoader";
import ScrollToTop from "./components/ScrollToTop";
import CookieBanner from "./components/CookieConsent/CookieBanner";
import CookieSettingsModal from "./components/CookieConsent/CookieSettingsModal";
import { getSiteIdentity } from "./services/themeService";

function App() {
  // ✅ Update favicon dynamically on mount
  useEffect(() => {
    const updateFavicon = async () => {
      try {
        const identity = await getSiteIdentity();
        const faviconLink = document.querySelector("link[rel='icon']") as HTMLLinkElement;
        if (faviconLink && identity.faviconUrl) {
          faviconLink.href = identity.faviconUrl;
        }
      } catch (error) {
        console.error('Failed to update favicon:', error);
      }
    };
    updateFavicon();
  }, []);

  return (
    <CookieConsentProvider>
      <AuthProvider>
        <CategoriesProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <ScrollToTop />
            <Suspense fallback={<FullPageLoader />}>
              <AppRoutes />
            </Suspense>
            <CookieBanner />
            <CookieSettingsModal />
          </BrowserRouter>
        </CategoriesProvider>
      </AuthProvider>
    </CookieConsentProvider>
  );
}

export default App;
